import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";

const API_PATH = "/api/internal/error";

@Injectable({ providedIn: "root" })
export class ErrorService {
  private readonly httpClient = inject(HttpClient);

  sendError(message: string): void {
    void firstValueFrom(this.httpClient.post(API_PATH, message));
  }
}
